import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";
import AxiosStatic from "axios";

let logger = newLogger("LeasingStore");

const urls = {
  getDealerBranding: (dealerId) =>
    `/api/administration/dealer/branding/external/${dealerId}`,
  downloadFile: (id) => `/api/file/public/${id}`,
  getFilterSettings: (dealerId) =>
    `/administration/offer/calculation-config/filter-settings/${dealerId}`,
};

const initState = () => {
  return {
    dealerId: null,
    publicId: null,
    dealerBranding: {},
    filterSettings: {},
  };
};

const actions = {
  fetchDealerBranding: async ({ commit }, dealerId) => {
    try {
      // const axios = await network.connection();
      const { data } = await AxiosStatic.get(urls.getDealerBranding(dealerId));

      commit("saveDealerBranding", data);

      if (data.bigLogo) {
        const bigLogoBlob = await AxiosStatic.get(
          urls.downloadFile(data.bigLogo),
          { responseType: "blob" }
        );
        const bigLogoUrl = URL.createObjectURL(bigLogoBlob.data);
        commit("saveBigLogo", bigLogoUrl);
      }
      if (data.compactLogo) {
        const compactLogoBlob = await AxiosStatic.get(
          urls.downloadFile(data.compactLogo),
          { responseType: "blob" }
        );
        const compactLogoUrl = URL.createObjectURL(compactLogoBlob.data);
        commit("saveCompactLogo", compactLogoUrl);
      }
      if (data.heroImage) {
        const heroImageBlob = await AxiosStatic.get(
          urls.downloadFile(data.heroImage),
          { responseType: "blob" }
        );
        const heroImageUrl = URL.createObjectURL(heroImageBlob.data);
        commit("saveHeroImage", heroImageUrl);
      }
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  saveLandingParams: async ({ commit }, { dealerId, publicId }) => {
    commit("saveLandingParams", { dealerId, publicId });
  },
  fetchFilterSettings: async ({ commit }, dealerId) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.getFilterSettings(dealerId));
      commit("saveFilterSettings", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveDealerBranding: (state, data) => {
    Vue.set(state, "dealerBranding", data);
  },
  saveBigLogo: (state, bigLogo) => {
    Vue.set(state.dealerBranding, "bigLogo", bigLogo);
  },
  saveCompactLogo: (state, compactLogo) => {
    Vue.set(state.dealerBranding, "compactLogo", compactLogo);
  },
  saveHeroImage: (state, heroImage) => {
    Vue.set(state.dealerBranding, "heroImage", heroImage);
  },
  saveLandingParams: (state, { dealerId, publicId }) => {
    Vue.set(state, "dealerId", dealerId);
    Vue.set(state, "publicId", publicId);
  },
  saveFilterSettings: (state, data) => {
    Vue.set(state, "filterSettings", data);
  },
};

const getters = {
  getDealerBranding: (state) => {
    return state.dealerBranding;
  },
  dealerId: (state) => {
    return state.dealerId;
  },
  publicId: (state) => {
    return state.publicId;
  },
  filterSettings: (state) => {
    return state.filterSettings;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
